import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { NotificationState } from './notification.state';
import { StateFilter } from '../crud.state';
import { Notification } from '../../models/notification';

const filterItems = (
  items: Notification[],
  filter: StateFilter,
  products = false
) => {
  return items.filter(item => {
    const titleMatch = item.title
      .toLowerCase()
      .includes(filter.query.toLowerCase());

    const idMatch =
      !filter.ids ||
      filter.ids.length === 0 ||
      filter.ids.includes(item._id) ||
      filter.ids.includes(item._id);

    return titleMatch && idMatch;
  });
};

export function withNotificationSelectors() {
  return signalStoreFeature(
    {
      state: type<NotificationState>(),
    },
    withComputed(({ items, filter, selectedId }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => {
        return Object.values(items()).sort((a, b) =>
          a.title < b.title ? -1 : 1
        );
      }),
      filteredSortedByName: computed(() => {
        let filtered = Object.values(items());
        if (filter()) {
          filtered = filterItems(filtered, filter());
        }
        return filtered.sort((a, b) => (a.title < b.title ? -1 : 1));
      }),
    }))
  );
}
